import React from 'react';
import { CONSULTANT_INFO } from '../../constants';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          Bu site {CONSULTANT_INFO.NAME} için oluşturulmuş ve onun tarafından yönetilmektedir.<br />
          Tüm hakları saklıdır - 2025
        </p>
        <div className="developer-credit">
          Software & Design by Muhammet ÇEVİK - For contact: <a href="mailto:muhammetcevik5551@gmail.com" className="developer-link">muhammetcevik5551@gmail.com</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
